import './collapse/scripts'
import './footer-contact/scripts'
import './navigation/scripts'
import './slider/scripts'



// WEBPACK FOOTER //
// ./src/components/index.js